import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { RegistryProvider } from "@/context/RegistryContext";
import { Nav } from "@/components/Nav";
import Landing from "@/pages/Landing";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import GuestRegistry from "@/pages/GuestRegistry";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <RegistryProvider>
            <Nav />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/onboarding" element={<Onboarding />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/r/:slug" element={<GuestRegistry />} />
            </Routes>
            <Toaster />
          </RegistryProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
